export function downloadXLSX(xlsx: any, name: string) {
  try {
    // Create a link to download the file
    const hiddenElement = document.createElement('a');
    hiddenElement.href = URL.createObjectURL(new Blob([xlsx], { type: 'application/octet-stream' }));
    hiddenElement.download = `${name}.xlsx`;
    hiddenElement.click();
  } catch (error) {
    console.error(`Failed to begin XSLX download`, error);
  }
}
